import { Capacitor } from '@capacitor/core'
import { useNavigate } from '@solidjs/router'
import OneSignal from 'onesignal-cordova-plugin'

function extractPathFromAppUrl(appUrl: string): string {
  const match = appUrl.match(/^[\w+.-]+:\/\/(.+)$/)
  if (match?.[1]) {
    return `/${match[1].replace(/^\/+/, '')}` // ensure leading slash
  }
  return '/'
}


function mobile() {
  const navigate = useNavigate()
    try {
    OneSignal.Notifications.addEventListener('click', (event) => {
      console.log('🔔 Notification clicked:', event)
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      const data: any = event?.notification?.additionalData
      const appUrl = data?.app_url ?? event?.notification?.launchURL
      console.log(appUrl)
      console.log(data)
      if (appUrl) {
        try {
          const path = extractPathFromAppUrl(appUrl)
          console.log('📍Navigating to:', path)
          navigate(path)
        } catch (err) {
          console.error('❌ Invalid deep link URL:', appUrl, err)
        }
      } else {
        console.warn('⚠️ No app_url or launchURL found in notification')
      }
    })
  } catch (err) {
    console.error('❌ listenForPushedRoute error:', err)
  }

}

// async function web() {
// 	const navigate = useNavigate()
// 	const OneSignal = (window as any).OneSignal
// 	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
// 	OneSignal.Notifications.addEventListener('click', ({ notification, result }: any) => {
// 		alert(JSON.stringify(result))
// 		alert(JSON.stringify(notification))
// 		if (notification.additionalData?.route) {
// 			navigate(notification.additionalData.route)
// 		}
// 	})
// }

export async function usePushEvents() {
	try {
		if (Capacitor.isNativePlatform()) {
			await mobile()
		} else {
			// await web()
		}
	} catch (err) {
		console.error('❌ listenForPushedRoute error:', err)
	}
}
